module.exports = __webpack_public_path__ + "img/gear.3003d9bb.svg";